import React from "react";
import styles from './textoGanador.module.css'


const TextoGanador = ({puntos}) => {


    return(
        <div className={styles.textoGanador}>
            <h2>¡QUÉ COOL!</h2>
            <p>Vas acumulando {puntos} chances de ganar.</p>
        </div>
    )
}



export default TextoGanador